import { LazyAction, LazyModule } from 'owa-bundling';

export const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarReadingPane"*/ './lazyIndex')
);

// Actions
export { default as showReadingPaneWithPerf } from './actions/showReadingPaneWithPerf';
export { default as popOutReadingPane } from './actions/popOutReadingPane';

// NOTE: These non-lazy actions are for subscription purposes only
//       Do not invoke outside of this package
export { onHideReadingPane, onShowReadingPane } from './actions/actionCompletedNotifications';

// Lazy-load actions
export const lazyHideReadingPane = new LazyAction(lazyModule, m => m.hideReadingPane);
export const lazyShowReadingPane = new LazyAction(lazyModule, m => m.showReadingPane);

export const lazyOpenReadingPaneSchedulingAssistant = new LazyAction(
    lazyModule,
    m => m.openReadingPaneSchedulingAssistant
);
export const lazyHandleReadingPaneSchedulingAssistantSave = new LazyAction(
    lazyModule,
    m => m.handleReadingPaneSchedulingAssistantSave
);
export const lazyHandleReadingPaneSchedulingAssistantDiscard = new LazyAction(
    lazyModule,
    m => m.handleReadingPaneSchedulingAssistantDiscard
);
